import React from "react";
import { connect } from "react-redux";

import { RouteProps } from "react-router";
import { UserRole } from "src/store/models/user.model";
import { IRootState } from "../../store/reducers";
import { hasAnyAuthority } from "../../util/roleAuthorization";

export interface IGuardedComponent extends RouteProps, StateProps {
  authorizedRoles?: UserRole[];
  authorizedUserEmails?: string[];
}

export class GuardedComponent extends React.Component<IGuardedComponent> {
  render() {
    const { authorizedRoles, authorizedUserEmails, user } = this.props;

    return (
      <React.Fragment>
        {hasAnyAuthority(user, authorizedRoles, authorizedUserEmails) ? this.props.children : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }: IRootState) => ({
  user: auth.user,
});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(GuardedComponent);
